import { DateBadgeInput } from "@/lib/Components/Form/Inputs/DateBadgeInput";

export function ClosedPickupDatesForm() {
  return (
    <DateBadgeInput
      className="col-span-full"
      name="closed_departure_dates"
      label="Closed pickup dates"
    />
  );
}
